export default __webpack_public_path__ + "images/c85a7bd60df5ec319904c085de00aaab.png";